var render = function render(){var _vm=this,_c=_vm._self._c;return _c('commonSelect',{attrs:{"value":_vm.value,"placeholder":"请选择仓库","clearable":_vm.clearable,"idKey":"WarehouseId","labelKey":"WarehouseName","get-data-func":_vm.getDataFunc},on:{"input":v=>_vm.$emit('input',v),"select":v=>_vm.$emit('change',v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }